import { ref, reactive } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e78d17bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-line",
  style: {
    "margin-top": "10px"
  }
}, "您可以创建订阅组, 订阅组中包括多个订阅型商品", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-line"
}, "对于一个订阅组，消费者只能订阅其中一个商品", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-line"
}, " 如果您希望消费者购买多个订阅型商品，可以把这些商品放在不同的订阅组中。例：电影会员组（月会员、年会员）、音乐会员（月会员、年会员） ", -1));
const _hoisted_4 = {
  style: {
    "text-align": "right"
  }
};
import { message } from 'ant-design-vue';
import { createSubscriptionGroup } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'SubscModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dbtId: null,
    prodChnl: null
  },
  emits: ['update:modalVisible', 'updateList'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const loading = ref(false);
    const formRef = ref();
    const formState = reactive({
      name: ''
    });
    const rules = {
      name: [{
        required: true,
        message: '请输入订阅组名称',
        trigger: 'change'
      }, {
        max: 30,
        message: '最大长度为30个字符',
        trigger: 'change'
      }]
    };
    const closeModal = () => {
      emit('update:modalVisible', false);
    }; // 关闭弹窗
    const addClick = async () => {
      formRef.value.validate().then(async () => {
        try {
          loading.value = true;
          const params = {
            dbtId: props.dbtId,
            chnlFlag: props.prodChnl,
            groupName: formState.name
          };
          const res = await createSubscriptionGroup(params);
          if (res.code === '0') {
            message.success('创建成功');
            closeModal();
            emit('updateList');
          }
        } finally {
          loading.value = false;
        }
      });
    }; // 创建
    const openModal = () => {
      formState.name = '';
    }; // 打开弹窗
    expose({
      openModal
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        maskClosable: !loading.value,
        closable: !loading.value,
        footer: false,
        title: "新增订阅组",
        width: "540px",
        onCancel: closeModal,
        centered: ""
      }, {
        default: _withCtx(() => [_hoisted_1, _hoisted_2, _hoisted_3, _createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formState,
          name: "basic",
          rules: rules,
          "label-col": {
            span: 5
          },
          "label-align": "left",
          "wrapper-col": {
            span: 16
          },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "订阅组名称",
            name: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formState.name,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formState.name = $event)
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
          style: {
            "margin-right": "8px"
          },
          onClick: closeModal,
          disabled: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_a_button, {
          type: "primary",
          onClick: addClick,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode("创建")]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      }, 8, ["open", "maskClosable", "closable"]);
    };
  }
});